import React, { useEffect, useMemo, useState } from 'react';
import { TableHeader } from 'components/TableHeader';
import { useParams } from 'react-router-dom';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { ServicesService } from 'services/ServicesService';
import { PageFormBox } from 'ui/PageFormBox';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { Spin } from 'antd';

const PackageServiceForm = React.lazy(() =>
  import('components/PackageServiceForm')
);

function PackageEdit() {
  useDocumentTitle('Редактирование услуги');
  useHeaderChanger('Редактирование услуги');
  const { id } = useParams('id');
  const [packageService, setPackageService] = useState(null);

  useEffect(() => {
    fetchPackageById();
  }, []);

  const pageBreadCrumbs = useMemo(
    () => [
      {
        id: 1,
        text: 'Услуги',
      },
      {
        id: 2,
        text: 'Все услуги',
        link: '/setting/services/packages',
      },
      {
        id: 3,
        text: 'Редактирование услуги',
        link: `/setting/services/edit/${id}`,
      },
    ],
    []
  );

  const fetchPackageById = async () => {
    const data = await ServicesService.getPackageById(id);
    if (data) setPackageService(data);
  };

  return (
    <>
      <TableHeader breadcrumbs={pageBreadCrumbs} hideAction />

      <PageFormBox>
        <React.Suspense fallback={<Spin />}>
          <PackageServiceForm initialValues={packageService} />
        </React.Suspense>
      </PageFormBox>
    </>
  );
}

export { PackageEdit };
